import { render, staticRenderFns } from "./JiCaiBuyer.vue?vue&type=template&id=38af3b48&"
import script from "./JiCaiBuyer.vue?vue&type=script&lang=js&"
export * from "./JiCaiBuyer.vue?vue&type=script&lang=js&"
import style0 from "./JiCaiBuyer.vue?vue&type=style&index=0&id=38af3b48&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38af3b48')) {
      api.createRecord('38af3b48', component.options)
    } else {
      api.reload('38af3b48', component.options)
    }
    module.hot.accept("./JiCaiBuyer.vue?vue&type=template&id=38af3b48&", function () {
      api.rerender('38af3b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/JiCaiBuyer.vue"
export default component.exports